import React, { Component } from "react";

import UserAPI from "../api/UserAPI";
import GroupAPI from "../api/GroupAPI";
import AlertConfirmation from "./confirmDelete.js";
import UsersList from "./users/UsersList";
import UserEdit from "./users/UserEdit";

import "../style.css";

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      user: null,
      groups: [],
      groupsOfSelectedUser: [],
      selectedGroup: {
        id: "",
        name: "",
        swaggerPermission: "READ"
      }
    };
  }

  loadUsersAndGroups() {
    UserAPI.getUsers().then(users => {
      this.setState({
        users: users
      });
    });

    GroupAPI.getGroups().then(groups => {
      this.setState({
        groups: groups
      });
    });
  }

  componentWillMount() {
    this.loadUsersAndGroups();
  }

  handleUserChange = event => {
    let user = this.state.user;
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    user[event.target.id] = value;
    this.setState({
      user: user
    });
  };

  handleGroupChange = event => {
    let selectedGroup = this.state.selectedGroup;
    if (event.target.name === "radioGroup") {
      selectedGroup.swaggerPermission = event.target.id;
    } else {
      const [id, name] = event.target.value.split("#");
      selectedGroup.id = id;
      selectedGroup.name = name;
    }
    this.setState({
      selectedGroup: selectedGroup
    });
  };

  addUserToGroup = () => {
    if (this.state.selectedGroup.id === "") {
      return;
    }

    let groups = this.state.groupsOfSelectedUser;
    groups.push(this.state.selectedGroup);
    this.setState({
      groupsOfSelectedUser: groups,
      selectedGroup: {
        id: this.state.selectedGroup.id,
        name: this.state.selectedGroup.name,
        swaggerPermission: this.state.selectedGroup.swaggerPermission
      }
    });
  };

  getUsersById = id => {
    UserAPI.getUser(id).then(user => {
      this.setState({
        user: user
      });
    });

    UserAPI.getUserGroups(id).then(groups => {
      this.setState({
        groupsOfSelectedUser: groups
      });
    });

    this.setState({
      action: "update"
    });
  };

  initUser = () => {
    const user = {
      lastname: "",
      firstname: "",
      username: "",
      email: "",
      isAdmin: false
    };
    this.setState({
      user: user,
      action: "create"
    });
  };

  insertUser = () => {
    if (this.state.action === "create") {
      this.createUser();
    } else if (this.state.action === "update") {
      this.updateUser();
    } else {
      return;
    }
  };

  updateUser() {
    UserAPI.updateUser(this.state.user.id, this.state.user)
      .then(result => {
        return UserAPI.setUserGroups(
          this.state.user.id,
          this.state.groupsOfSelectedUser
        );
      })
      .then(result => {
        this.setState({
          user: null,
          groupsOfSelectedUser: []
        });
        this.loadUsersAndGroups();
      });
  }

  createUser() {
    UserAPI.createUser(this.state.user)
      .then(user => {
        return UserAPI.setUserGroups(user.id, this.state.groupsOfSelectedUser);
      })
      .then(result => {
        this.setState({
          user: null,
          groupsOfSelectedUser: []
        });
        this.loadUsersAndGroups();
      });
  }

  deleteUser(id) {
    UserAPI.deleteUser(id).then(result => {
      this.loadUsersAndGroups();
    });
  }

  confirmDelete = (id, username) => {
    const deleteHandler = onClose => {
      this.deleteUser(id);
      onClose();
    };
    AlertConfirmation.confirmDelete(
      deleteHandler,
      `Do you want to delete the user ${username} ?`
    );
  };

  deleteGroup = groupId => {
    const groups = this.state.groupsOfSelectedUser.filter(group => {
      return group.id !== groupId;
    });
    this.setState({
      groupsOfSelectedUser: groups
    });
  };

  render() {
    return (
      <div className="users-div">
        <div className="users-div-left">
          <UsersList
            users={this.state.users}
            onEdit={this.getUsersById}
            onDelete={this.confirmDelete}/>
        </div>
        <div className="users-div-right">
          <UserEdit
            user={this.state.user}
            groups={this.state.groups}
            groupsOfUser={this.state.groupsOfSelectedUser}
            onChange={this.handleUserChange}
            onGroupChange={this.handleGroupChange}
            onGroupSubmit={this.addUserToGroup}
            onGroupDelete={this.deleteGroup}
            onCreate={this.initUser}
            onSubmit={this.insertUser}/>
        </div>
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/components/Users.js